import _regeneratorRuntime from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Circle, CircleWarp, ParticlesInteractorBase } from "../../../Core";
import { getDistance, getLinkRandomColor } from "../../../Utils";

function getLinkDistance(pos1, pos2, optDistance, canvasSize, warp) {
  var distance = getDistance(pos1, pos2);

  if (!warp || distance <= optDistance) {
    return distance;
  }

  var pos2NE = {
    x: pos2.x - canvasSize.width,
    y: pos2.y
  };
  distance = getDistance(pos1, pos2NE);

  if (distance <= optDistance) {
    return distance;
  }

  var pos2SE = {
    x: pos2.x - canvasSize.width,
    y: pos2.y - canvasSize.height
  };
  distance = getDistance(pos1, pos2SE);

  if (distance <= optDistance) {
    return distance;
  }

  var pos2SW = {
    x: pos2.x,
    y: pos2.y - canvasSize.height
  };
  distance = getDistance(pos1, pos2SW);
  return distance;
}

export var Linker = /*#__PURE__*/function (_ParticlesInteractorB) {
  _inherits(Linker, _ParticlesInteractorB);

  var _super = _createSuper(Linker);

  function Linker(container) {
    _classCallCheck(this, Linker);

    return _super.call(this, container);
  }

  _createClass(Linker, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.options.links.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(p1) {
        var _a, pos1, container, canvasSize, linkOpt1, optOpacity, optDistance, warp, range, query, _iterator, _step, p2, linkOpt2, pos2, distance, opacityLine;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                p1.links = [];
                pos1 = p1.getPosition();
                container = this.container;
                canvasSize = container.canvas.size;

                if (!(pos1.x < 0 || pos1.y < 0 || pos1.x > canvasSize.width || pos1.y > canvasSize.height)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                linkOpt1 = p1.options.links;
                optOpacity = linkOpt1.opacity;
                optDistance = (_a = p1.retina.linksDistance) !== null && _a !== void 0 ? _a : container.retina.linksDistance;
                warp = linkOpt1.warp;
                range = warp ? new CircleWarp(pos1.x, pos1.y, optDistance, canvasSize) : new Circle(pos1.x, pos1.y, optDistance);
                query = container.particles.quadTree.query(range);
                _iterator = _createForOfIteratorHelper(query);
                _context.prev = 13;

                _iterator.s();

              case 15:
                if ((_step = _iterator.n()).done) {
                  _context.next = 31;
                  break;
                }

                p2 = _step.value;
                linkOpt2 = p2.options.links;

                if (!(p1 === p2 || !linkOpt2.enable || linkOpt1.id !== linkOpt2.id || p2.spawning || p2.destroyed || p1.links.map(function (t) {
                  return t.destination;
                }).indexOf(p2) !== -1 || p2.links.map(function (t) {
                  return t.destination;
                }).indexOf(p1) !== -1)) {
                  _context.next = 20;
                  break;
                }

                return _context.abrupt("continue", 29);

              case 20:
                pos2 = p2.getPosition();

                if (!(pos2.x < 0 || pos2.y < 0 || pos2.x > canvasSize.width || pos2.y > canvasSize.height)) {
                  _context.next = 23;
                  break;
                }

                return _context.abrupt("continue", 29);

              case 23:
                distance = getLinkDistance(pos1, pos2, optDistance, canvasSize, warp && linkOpt2.warp);

                if (!(distance > optDistance)) {
                  _context.next = 26;
                  break;
                }

                return _context.abrupt("return");

              case 26:
                opacityLine = (1 - distance / optDistance) * optOpacity;
                this.setColor(p1);
                p1.links.push({
                  destination: p2,
                  opacity: opacityLine
                });

              case 29:
                _context.next = 15;
                break;

              case 31:
                _context.next = 36;
                break;

              case 33:
                _context.prev = 33;
                _context.t0 = _context["catch"](13);

                _iterator.e(_context.t0);

              case 36:
                _context.prev = 36;

                _iterator.f();

                return _context.finish(36);

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[13, 33, 36, 39]]);
      }));

      function interact(_x) {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }, {
    key: "setColor",
    value: function setColor(p1) {
      var container = this.container;
      var linksOptions = p1.options.links;
      var linkColor = linksOptions.id === undefined ? container.particles.linksColor : container.particles.linksColors.get(linksOptions.id);

      if (!linkColor) {
        var optColor = linksOptions.color;
        linkColor = getLinkRandomColor(optColor, linksOptions.blink, linksOptions.consent);

        if (linksOptions.id === undefined) {
          container.particles.linksColor = linkColor;
        } else {
          container.particles.linksColors.set(linksOptions.id, linkColor);
        }
      }
    }
  }]);

  return Linker;
}(ParticlesInteractorBase);